// Mirrors cinemadb's CredentialPermissions. The API is the real gate; this only decides which
// controls to show. Codes come from the service roles returned by /users/me.
const VIEW_ROLES = ["cdb-admin", "cdb-device-manager", "cdb-tech-support", "cdb-ops"];
const EDIT_ROLES = ["cdb-admin", "cdb-device-manager"];

// cinemadb compares `code.parameterize` (Rails), so "CDB Admin" and "cdb-admin" are the same role.
// Do the same here, or the controls silently disappear for roles whose code isn't already in
// that form.
export const normalizeRoleCode = (code) =>
  String(code ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9\-_]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "");

const hasAny = (roleCodes, allowed) => (roleCodes ?? []).some((code) => allowed.includes(code));

export const canViewCredentials = (roleCodes) => hasAny(roleCodes, VIEW_ROLES);
export const canRevealCredentials = (roleCodes) => hasAny(roleCodes, VIEW_ROLES);
export const canEditCredentials = (roleCodes) => hasAny(roleCodes, EDIT_ROLES);
